import {
  getSantanderPaymentReports,
  exportAccumulatedAutomaticDebitReport
} from 'src/services/santanderClabeService';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import { SnackBarVariants } from 'src/utils/constants/common';
import { SantanderReportType } from 'src/utils/constants/clients';
import { showMessage } from './snackBarActions';
import { selectSantanderDomiciledCollectionQueryOptions } from '../selectors/santanderDomiciledCollectionSelectors';

export const LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS = asyncActionCreator(
  'LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS'
);
export const SAVE_SANTANDER_DOMICILED_COLLECTION_OPTIONS = asyncActionCreator(
  'SAVE_SANTANDER_DOMICILED_COLLECTION_OPTIONS'
);
export const DOWNLOAD_SANTANDER_DOMICILED_COLLECTION = asyncActionCreator(
  'DOWNLOAD_SANTANDER_DOMICILED_COLLECTION'
);
export const CLEAR_SANTANDER_DOMICILED_COLLECTION_OPTIONS = 'CLEAR_SANTANDER_DOMICILED_COLLECTION_OPTIONS';

function getDomiciledCollectionReportsOptions(getState, sendLimit = true) {
  const queryOpts = selectSantanderDomiciledCollectionQueryOptions(getState());

  const reqOptions = {
    reportType: SantanderReportType.AUTOMATIC_DEBIT
  };

  if (queryOpts.page > 0) {
    reqOptions.offset =
      queryOpts.page * Number(process.env.REACT_APP_TABLE_SIZE);
  }
  if (sendLimit) {
    reqOptions.limit = queryOpts.limit;
  }
  if (queryOpts.startDate) {
    reqOptions.startDate = queryOpts.startDate;
  }
  if (queryOpts.endDate) {
    reqOptions.endDate = queryOpts.endDate;
  }

  return reqOptions;
}

export const loadSantanderDomiciledCollectionReports = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.start });

    dispatch({
      type: SAVE_SANTANDER_DOMICILED_COLLECTION_OPTIONS,
      options
    });

    const reqOptions = getDomiciledCollectionReportsOptions(getState);

    const data = await getSantanderPaymentReports(reqOptions);
    return dispatch({
      type: LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.success,
      data
    });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    return dispatch({ type: LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.failure });
  }
};

export const downloadSantanderDomiciledCollectionAction = ({
  startDate,
  endDate
}) => async dispatch => {
  try {
    dispatch({ type: DOWNLOAD_SANTANDER_DOMICILED_COLLECTION.start });
    await exportAccumulatedAutomaticDebitReport({ startDate, endDate });
    return dispatch({ type: DOWNLOAD_SANTANDER_DOMICILED_COLLECTION.success });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: DOWNLOAD_SANTANDER_DOMICILED_COLLECTION.failure });
  }
};

